import { DtoRequestHolidaysPostReq } from "./abst/DtoRequestHolidaysPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestHolidaysPostReqImple extends DtoRequestHolidaysPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
